module.exports = __webpack_public_path__ + "img/welcome_b.c6155437.jpg";